import React, { useEffect, useState } from 'react'
import objectPath from 'object-path'
import Count from './custom/Count'
import Table from './custom/Table'
import { debounceCallback } from 'utility/debounceCallback.util'

const CustomComponent = (props) => {
  const { chart } = props
  const chartType = objectPath.get(chart, 'chart.type')
  if (chartType === 'count') {
    return <Count {...props} />
  }
  if (chartType === 'table') {
    return <Table {...props} />
  }
  return <></>
}

const CustomSample = (props) => {
  const { dashboardKey } = props
  const [firstRender, setFirstRender] = useState(true)

  useEffect(() => {
    debounceCallback(setFirstRender, [false], `render-${dashboardKey}`, 200)
  }, [dashboardKey])

  return (
    <div
      className="d-flex justify-content-center"
      style={{
        opacity: firstRender ? '0' : '100%',
        transition: 'all .5s ease-in-out',
      }}
    >
      <CustomComponent {...props} />
    </div>
  )
}

export default CustomSample
